import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-select-language',
  templateUrl: './select-language.component.html',
  styleUrls: ['./select-language.component.scss']
})
export class SelectLanguageComponent implements OnInit {
    public langs = [
        {
            label: 'Español', abr: 'es',
        },
        {
            label: 'English', abr: 'en',
        },
    ];

    public currentLang = { label: '', abr: '' };
    public openLang = false;
    constructor( public translate: TranslateService ) { }

    ngOnInit() {
        if ( !this.translate.currentLang ) {
            this.currentLang = this.langs[0];
            this.translate.setDefaultLang(this.langs[0].abr);
            this.translate.use(this.langs[0].abr);
        } else {
            this.currentLang =  this.langs.filter(x => x.abr === this.translate.currentLang)[0];
        }
    }

    public openSelectLang() {
        event.preventDefault();
        this.openLang = !this.openLang;
    }

    public changeLang(lang) {
        event.preventDefault();
        this.currentLang = lang;
        this.translate.use(lang.abr);
        this.openLang = false;
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/language/components/select-language/select-language.component.ts